// Scheduled agents — Phase 3 placeholder list. Phase 7 polishes the
// detail view; the list view wires up to the existing api.listAgents()
// localStorage-backed seed already.

import { Pause, Play, Sparkles } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useStore } from "@/lib/store";

export function AgentsPage() {
  const { agents, toggleAgent, route } = useStore();
  const detail = route.agentId
    ? agents.find((a) => a.id === route.agentId)
    : null;

  if (route.agentId && detail) {
    return (
      <div className="mx-auto w-full max-w-[1200px] px-6 md:px-10 py-12 space-y-6">
        <div className="flex items-center gap-3 text-muted-foreground">
          <Sparkles className="h-5 w-5" />
          <p className="text-tiny tracking-[0.18em] uppercase">Agent</p>
        </div>
        <h1 className="font-freight text-4xl font-light tracking-tight leading-tight">
          {detail.title}
        </h1>
        <p className="text-muted-foreground max-w-xl">{detail.desc}</p>
        <div className="flex items-center gap-3 text-sm">
          <span className="font-mono text-xs uppercase tracking-wider text-muted-foreground">
            {detail.cadence}
          </span>
          <span className="text-muted-foreground/50">·</span>
          <span className="text-muted-foreground">
            Last run: {detail.lastRun}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-[1200px] px-6 md:px-10 py-12 space-y-8">
      <div className="space-y-2">
        <p className="text-tiny tracking-[0.18em] uppercase text-muted-foreground">
          Scheduled intelligence
        </p>
        <h1 className="font-freight text-5xl font-light tracking-tight leading-none">
          Agents
        </h1>
        <p className="text-muted-foreground max-w-xl">
          Recurring agents that watch your live work and surface what
          changed.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {agents.map((a) => (
          <div
            key={a.id}
            className="rounded-lg border border-border bg-card p-6 shadow-card"
          >
            <div className="flex items-start justify-between gap-3 mb-4">
              <div className="space-y-1">
                <p className="text-tiny tracking-[0.18em] uppercase text-muted-foreground">
                  {a.cadence}
                </p>
                <h3 className="font-freight text-2xl font-light tracking-tight leading-tight">
                  {a.title}
                </h3>
              </div>
              <Button
                onClick={() => toggleAgent(a.id)}
                variant="ghost"
                size="icon-sm"
                className={
                  a.status === "scheduled" ? "text-foreground" : "text-muted-foreground"
                }
              >
                {a.status === "scheduled" ? (
                  <Pause className="h-4 w-4" />
                ) : (
                  <Play className="h-4 w-4" />
                )}
              </Button>
            </div>
            <p className="text-sm text-muted-foreground">{a.desc}</p>
            <p className="mt-4 text-xs text-muted-foreground/70 font-mono">
              {a.status} · last run {a.lastRun}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
